module.exports = __webpack_public_path__ + "img/car_00019.6ee9439d.jpg";